export const ORGANIZATIONS_ROOT = '/organizations'
export const TRIAL_ORGANIZATIONS = '/organizations/trial'
export const VIEW_ORGANIZATION = '/organizations/:id/:tab?'

export const ORGANIZATIONS_API_ALL = '/organizations/organizations'

export const makeSingleOrganizationPath = (organizationId, tab) => (
  VIEW_ORGANIZATION.replace(':id', organizationId).replace(':tab?', tab || '')
)